import { PortalMessage } from '@components/portalMessage/PortalMessage';
import { QuoteGetResponse } from '@lio/api-types';
import { Box } from '@mui/material';
import { PortalMessageType } from '@components/portalMessage/PortalMessageType.enum';
import { Button } from '@components/button';
import { useGetScreenSize } from '@utils/useGetScreenSize';
import { useLogoutHook } from '@hooks/useLogoutHook';
import { useGetBrokerage } from '@services/brokerage';
import Loading from '@components/Loading';
import { QuoteStatus } from '@models/quotes';

export const CUBlockingMessage = ({ quote }: { quote: QuoteGetResponse }) => {
  const { isMobileScreen } = useGetScreenSize();
  const { handleLogout } = useLogoutHook();

  const brokerageId = quote?.brokerage?.id;

  const { brokerage, isLoading } = useGetBrokerage({ brokerageId, isEnabled: !!brokerageId });

  if (isLoading) {
    return <Loading />;
  }

  let email = quote.brokerageProducer.user.email;

  const brokerageEmails = (brokerage as any)?.emails ?? []; // ANY until types are updated

  if (brokerageEmails.length > 0) {
    email = brokerageEmails[0].email;
  }

  let showSuccessCheck = true;
  let title = 'Thank you for your submission!';
  let bodyText = `Based on the provided information, there is further review needed. Please reach out to our team at ${email} with any questions`;
  let footer: string | null = 'Thank you for choosing LIO!';
  if (quote?.status?.id === QuoteStatus.Expired.id) {
    showSuccessCheck = false;
    title = 'This quote has expired.';
    bodyText = `It appears the quote you are searching for has lapsed. Please reach out to our team at ${email} and we will work with you to reactivate the quote.`;
  }
  if ([QuoteStatus.Rejected.id, QuoteStatus.Declined.id, QuoteStatus.Canceled.id].includes(quote?.status?.id)) {
    showSuccessCheck = false;
    title = `Sorry, we can't quote this.`;
    bodyText = `This event does not meet the underwriting guidelines for this product. If you have any questions or would like to speak with someone on the team, please reach out to ${email}. Thank you.`;
    footer = null;
  }

  return (
    <PortalMessage
      type={PortalMessageType.CustomerUserBlocking}
      showSuccessCheck={showSuccessCheck}
      sxProps={{ leftSide: { width: '454px' } }}
      title={[title]}
      subtitle={[
        <Box component='div' key='main-text' sx={{ maxWidth: 400 }}>
          {bodyText}
        </Box>,
        footer && (
          <Box key='thanks-text' component='span' sx={{ display: 'flex', flexDirection: 'column', fontWeight: 'bold' }}>
            {footer}
          </Box>
        ),
        <Button fullWidth={isMobileScreen} key='logout' variant='contained' onClick={handleLogout}>
          Log Out
        </Button>,
      ]}
      quote={quote}
    />
  );
};
